import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import WalletIcon from "src/assets/svg-icons/wallet.svg";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

interface IProps {}

const PreBookingPaymentFailed: React.FC<IProps> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();

  const navigateToBooking = () => {
    navigate(`/pre-booking/${params.locationId}`);
  };

  return (
    <Box borderRadius={"12px"} overflow={"hidden"}>
      <Stack
        padding={"30px 113px 100px 113px"}
        alignItems={"center"}
        bgcolor={"#272727"}
      >
        <img src={WalletIcon} alt="" />
        <Typography
          mb={"60px"}
          color={"primary"}
          fontSize={"24px"}
          fontWeight={700}
          textTransform={"uppercase"}
          align="center"
        >
          {t("paymentFailed")}!
        </Typography>
        <Typography mb={2} align="center">
          {t("ifYouWantTryAgain")}
        </Typography>
        <Button
          sx={{ minWidth: "210px" }}
          variant="contained"
          size="large"
          onClick={navigateToBooking}
        >
          {t("clickHere")}
        </Button>
      </Stack>
    </Box>
  );
};

export default PreBookingPaymentFailed;
